import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Module } from "@modules/agreements/types";
import { ModuleFormValues } from "@modules/agreements/validations";

import { editModuleService } from "./service";
import { UseEditModuleMutationOptions } from "./types";

export function useEditModuleMutation(
  options?: UseEditModuleMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Module, ApiError, { id: string; data: ModuleFormValues }>({
    mutationFn: ({ id, data }) => editModuleService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("module_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
